import passwordReset from './password_reset';
import signin from './signin';

export default {
  signin,
  passwordReset,
};
